import React, { Component } from "react";
import "./ColorPicker.css";

const tc = require("tinycolor2");

class ColorPickerItem extends Component {
  handleClick = (e) => {
    if (this.props.color.getAlpha() === 1) this.props.onClick(this.props.color);
    else {
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    }
  };

  renderTexts = () => {
    const color = this.props.color.clone().setAlpha(1);

    return (
      <>
        <span className="ColorPickerItemText Spaced">
          {this.props.contrastingColor
            ? `CBkg=${tc.readability(color, this.props.contrastingColor).toFixed(2)}`
            : `CB=${tc.readability(color, "hsl(0, 0, 0)").toFixed(2)}, CW=${tc
                .readability(color, "hsl(0, 1, 1)")
                .toFixed(2)}`}
        </span>
        {/* <span className="ColorPickerItemText Spaced">{`LUM=${color.getLuminance().toFixed(2)}`}</span> */}
        <span className="ColorPickerItemText">{color.toHexString()}</span>
        <span className="ColorPickerItemText">{color.toRgbString()}</span>
        <span className="ColorPickerItemText">{color.toHslString()}</span>
      </>
    );
  };

  render() {
    const color = this.props.color;
    const validColor = color.getAlpha() === 1;
    const fontColor = !validColor ? "gray" : color.isLight() ? "black" : "white";
    const disabledClass = !validColor ? "Disabled" : "";

    return (
      <div
        className={"ColorPickerItemDiv " + disabledClass}
        style={{ backgroundColor: color.toString(), color: fontColor }}
        onClick={this.handleClick}
      >
        {this.renderTexts()}
      </div>
    );
  }
}

class ColorPicker extends Component {
  render() {
    return (
      <div className="ColorPickerPanelDiv">
        <div className="ColorPickerCategoriesDiv">
          {this.props.categories.map((category, cindex) => (
            <div className="ColorPickerCategoryDiv" key={cindex}>
              <span className="ColorPickerCategoryTitle">{category.name}</span>
              <div className="ColorPickerItemsDiv" key={cindex}>
                {category.colors.map((item, index) => (
                  <ColorPickerItem
                    key={index}
                    color={item}
                    contrastingColor={this.props.contrastingColor}
                    onClick={this.props.onColorClick}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default ColorPicker;
